/* Native details provides keyboard and no-JavaScript navigation. */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.se-shop[open]');
  if (!menu) return;
  menu.removeAttribute('open');
  menu.querySelector('summary').focus();
});
document.addEventListener('click', (event) => {
  const menu = document.querySelector('.se-shop[open]');
  if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
});
